import { render, staticRenderFns } from "./sendSms.vue?vue&type=template&id=000d45e8&"
import script from "./sendSms.vue?vue&type=script&lang=js&"
export * from "./sendSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports